import React from 'react';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Hidden from '@material-ui/core/Hidden';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { coursePropTypes } from '@anu/utilities/transform.course';
import { getPwaSettings } from '@anu/utilities/settings';
import DownloadCoursePopup from '@anu/components/DownloadCoursePopup';
import LinearProgress from '@material-ui/core/LinearProgress';
import { getUserId } from '@anu/utilities/settings';
import { allow_lms } from '@anu/utilities/settings';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    [theme.breakpoints.up('md')]: {
      borderBottom: '1px solid ' + theme.palette.grey[300],
    },
  },
  title: {
    paddingRight: theme.spacing(2),
    fontSize:[35, "!important"],
    marginBottom:0 + '!important',
    paddingRight:[20],
    paddingTop:[20],
    paddingLeft:[20],
    paddingBottom:[0],
    backgroundColor:theme.palette.coursesbtn.main,
  },
  description: {
    backgroundColor:theme.palette.coursesbtn.main,
    paddingRight:[20],
    paddingTop:[20],
    paddingLeft:[20],
    paddingBottom:[20],
  },
  label: {
    borderRadius: '4px',
    padding: theme.spacing(1, 1.5),
    background: theme.palette.grey[200],
    ...theme.typography.label2,
    marginRight: theme.spacing(1),
  },
  actions: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'flex-end',
    },
  },
  progress: {
    marginTop: theme.spacing(5),
    marginBottom: theme.spacing(1),
    height: 12,
    width: '100%',
    flexGrow: 2,
    borderRadius: 5,
    backgroundColor: theme.palette.grey[300],
    '& .MuiLinearProgress-barColorPrimary': {
      backgroundColor: theme.palette.accent3.main,
    },
  },
  lockIcon: {
    color: theme.palette.grey[400],
    fontSize: 20,
    alignSelf: 'flex-start',
    marginLeft: 'auto',
  },
  completed: {
    backgroundColor: theme.palette.success.main,
    height: 50,
    width: 50,
    marginLeft: theme.spacing(2),
    marginTop: -50,
    border: '1px solid white',
  },
  certificate:{
    display:'flex',
    justifyContent:'space-between',
    width: 'inherit',
    padding: '5px 80px',
    backgroundColor:'#FCF0F0',
    borderRadius:15,
    margin:'30px 20px'
  },
  download:{
    backgroundColor:theme.palette.secondary.main,
    borderRadius: 10,
    color: theme.palette.secondary.contrastText + '!important',
    padding: 10,
    height:46,
    margin:'auto 0',
  },
  medalIcon:{
    width:30,
    height:30,
    margin: 'auto 0',
  },
  medalFlex:{
    display:'flex',
  },
  certificateHeader:{
    fontSize:'28px' + '!important',
    marginLeft: 10,
    color:'black',

  }

}));

const LessonHeader = ({ course }) => {
  const classes = useStyles();
  const allowcertificate = $('#anu-application').attr('data-allowcertificate');

 return (
    <Box pt={[2, 3]} pb={[2, 3]} className={classes.wrapper}>
      <Container maxWidth={false}>
        <Grid container spacing={2} style={{ alignItems: 'center' }}>
          <Grid item xs={12} md={12}>
            {course && course.title && (
              <Typography variant="h5" component="h1" className={classes.title}>
                {course.title}
              </Typography>
            )}

            <Box>
              <Typography
                variant="body2"
                component="div"
                className={`${classes.description} ${course.locked && 'locked'}`}
                dangerouslySetInnerHTML={{ __html: course.short_description }}
                style={{"font-size":"1.1rem"}}
              />
            </Box>
            {course.progress &&
              course.progress_percent > 0 && allow_lms === true  && (
                <LinearProgress
                  className={classes.progress}
                  variant="determinate"
                  value={course.progress_percent}
                />
              )}
            {allowcertificate == 1 && course.certificate == true &&
              <div className={classes.certificate}>
                <div className={classes.medalFlex}>
                <svg className={classes.medalIcon} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M16 0H144c5.3 0 10.3 2.7 13.3 7.1l81.1 121.6c-49.5 4.1-94 25.6-127.6 58.3L2.7 24.9C-.6 20-.9 13.7 1.9 8.5S10.1 0 16 0zM509.3 24.9L401.2 187.1c-33.5-32.7-78.1-54.2-127.6-58.3L354.7 7.1c3-4.5 8-7.1 13.3-7.1H496c5.9 0 11.3 3.2 14.1 8.5s2.5 11.5-.8 16.4zM432 336c0 97.2-78.8 176-176 176s-176-78.8-176-176s78.8-176 176-176s176 78.8 176 176zM264.4 241.1c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z"/></svg>
                <h3 className={classes.certificateHeader}>
               Congratulations, you have earned a certificate!
              </h3>
                </div>
              <a href={drupalSettings.path.baseUrl+"node/" + course.id + "/generate_pdf"} className={classes.download} target="_blank">Download certificate</a>
              </div>
            }
            <Box mt={[0, 2]}>
              <Typography
                variant="body2"
                component="div"
                className={`${classes.description} ${course.locked && 'locked'}`}
                dangerouslySetInnerHTML={{ __html: course.description }}

              />
            </Box>
            {course && getPwaSettings() && (
              <Hidden smDown>
                <Box mx={-1} mt={2}>
                  <DownloadCoursePopup course={course} showButton={true} />
                </Box>
              </Hidden>
            )}
           {allow_lms === false &&
             <div>
                 <h5 style={{ "margin-top": "15px", "textAlign": "center", "padding": "10px 0" }}>
                   You don't have access to this content.
                 </h5>
               <p style={{ "textAlign": "center" }}>If you don't have an account, please click here to <a href={drupalSettings.path.baseUrl + "user/register"} target="_blank">Register</a> | If you already have an account please click here to <a href={drupalSettings.path.baseUrl + "user/login"} target="_blank">Login</a></p>
             </div>
           }

          </Grid>


        </Grid>
      </Container>
    </Box>

  );
};

LessonHeader.propTypes = {
  course: coursePropTypes,
};

LessonHeader.defaultProps = {
  course: null,
};

export default LessonHeader;
